var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 23,
    rx: 5.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7441 6.28809C13.8151 6.28809 14.6582 6.52507 15.2734 6.99902C15.8932 7.47298 16.2031 8.13151 16.2031 8.97461C16.2031 9.65365 16.0299 10.1914 15.6836 10.5879C15.3372 10.9798 14.8428 11.2282 14.2002 11.333V11.374C15.057 11.4834 15.695 11.7591 16.1143 12.2012C16.5381 12.6387 16.75 13.2539 16.75 14.0469C16.75 15.0039 16.4515 15.7581 15.8545 16.3096C15.262 16.861 14.4463 17.1367 13.4072 17.1367C12.4958 17.1367 11.7529 16.9932 11.1787 16.7061V20.3633H9.09375V9.50781C9.09375 8.48698 9.41276 7.69629 10.0508 7.13574C10.6888 6.57064 11.5866 6.28809 12.7441 6.28809ZM12.6895 7.91504C11.6823 7.91504 11.1787 8.51204 11.1787 9.70605V14.9971C11.3975 15.1383 11.6663 15.2546 11.9854 15.3457C12.3044 15.4323 12.6006 15.4756 12.874 15.4756C13.4574 15.4756 13.8903 15.3343 14.1729 15.0518C14.4554 14.7692 14.5967 14.3727 14.5967 13.8623C14.5967 13.361 14.444 12.9805 14.1387 12.7207C13.8379 12.4564 13.3981 12.3242 12.8193 12.3242H12.3271V10.6699H12.6895C13.1406 10.6699 13.4915 10.5469 13.7422 10.3008C13.9928 10.0501 14.1182 9.69238 14.1182 9.22754C14.1182 8.80827 13.9928 8.4847 13.7422 8.25684C13.4915 8.02897 13.1406 7.91504 12.6895 7.91504Z",
    fill: "#2C3038"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 23,
    rx: 5.5,
    stroke: "#CAD3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeta);
export default __webpack_public_path__ + "static/media/beta.04175287.svg";
export { ForwardRef as ReactComponent };